import { Component, ElementRef, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { LayoutService } from '../../services/layout.service';
import icBookmarks from '@iconify/icons-ic/twotone-bookmarks';
import emojioneUS from '@iconify/icons-emojione/flag-for-flag-united-states';
import emojioneDE from '@iconify/icons-emojione/flag-for-flag-germany';
import icMenu from '@iconify/icons-ic/twotone-menu';
import { ConfigService } from '../../services/config.service';
import { map } from 'rxjs/operators';
import icPersonAdd from '@iconify/icons-ic/twotone-person-add';
import icAssignmentTurnedIn from '@iconify/icons-ic/twotone-assignment-turned-in';
import icBallot from '@iconify/icons-ic/twotone-ballot';
import icDescription from '@iconify/icons-ic/twotone-description';
import icAssignment from '@iconify/icons-ic/twotone-assignment';
import icReceipt from '@iconify/icons-ic/twotone-receipt';
import icDoneAll from '@iconify/icons-ic/twotone-done-all';
import { NavigationService } from '../../services/navigation.service';
import icArrowDropDown from '@iconify/icons-ic/twotone-arrow-drop-down';
import { PopoverService } from '@vex/components/popover/popover/popover.service';
import { MegaMenuComponent } from '@vex/components/popover/mega-menu/mega-menu.component';
import icSearch from '@iconify/icons-ic/twotone-search';
import { Icons } from '@vex/icons/icons';
import { NavigationLink } from '@vex/interfaces/navigation-item.interface';
import { ModuleService } from '@vex/http-service/module.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { GlobalConsoleComponent } from '@vex/components/global-console/global-console.component';
import { GlobalKumobotComponent } from '@vex/components/global-kumobot/global-kumobot.component';
import { GlobalSearchComponent } from '@vex/components/global-search/global-search.component';
import { AccountService } from '@vex/http-service/account.service';
import { AuthService } from '@vex/http-service/auth.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'environments/environment';

interface OrganizationMembership {
    OrganizationId: string;
    OrganizationName: string;
    IsPrimary: boolean;
    Active: boolean;
}

@Component({
    selector: 'vex-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent extends Icons implements OnInit, OnDestroy {
    private readonly tenantBarVisibilityStorageKey = 'tenant-context-bar-visible';
    private readonly tenantBarVisibilityEventName = 'tenant-context-bar-visibility-changed';
    @Input() mobileQuery: boolean;

    @Input()
    @HostBinding('class.shadow-b')
    hasShadow: boolean;
    showHeader: boolean = true;
    navigationItems = [];
    imageUrl$ = "https://kumoraistdevfewus01.blob.core.windows.net/company-logo/kumorai.png";
    //this.configService.config$.pipe(map((config) => config.sidenav.imageUrl));
    isHorizontalLayout$ = this.configService.config$.pipe(
        map((config) => config.layout === 'horizontal')
    );
    isVerticalLayout$ = this.configService.config$.pipe(
        map((config) => config.layout === 'vertical')
    );
    isNavbarInToolbar$ = this.configService.config$.pipe(
        map((config) => config.navbar.position === 'in-toolbar')
    );
    isNavbarBelowToolbar$ = this.configService.config$.pipe(
        map((config) => config.navbar.position === 'below-toolbar')
    );

    icSearch = icSearch;
    icBookmarks = icBookmarks;
    emojioneUS = emojioneUS;
    emojioneDE = emojioneDE;
    icMenu = icMenu;
    icPersonAdd = icPersonAdd;
    icAssignmentTurnedIn = icAssignmentTurnedIn;
    icBallot = icBallot;
    icDescription = icDescription;
    icAssignment = icAssignment;
    icReceipt = icReceipt;
    icDoneAll = icDoneAll;
    icArrowDropDown = icArrowDropDown;
    breadcrumbs = [];
    organizationMemberships: OrganizationMembership[] = [];
    activeOrganizationId: string;
    homeOrganizationId: string;
    isSwitchingOrganization = false;
    switchingOrganizationId: string;
    organizationSearch = '';
    tenantBarVisible = true;
    private tenantBarVisibilityListener = () => this.loadTenantBarVisibility();

    constructor(
        public layoutService: LayoutService,
        private configService: ConfigService,
        private navigationService: NavigationService,
        private moduleService: ModuleService,
        private router: Router,
        private popoverService: PopoverService,
        private dialog: MatDialog,
        private accountService: AccountService,
        private authService: AuthService,
        private toastrService: ToastrService
    ) {
        super();
        this.navigationService.getItem().subscribe((d) => {
            this.navigationItems = d;
        });
    }

    ngOnInit() {
        this.loadTenantBarVisibility();
        window.addEventListener(this.tenantBarVisibilityEventName, this.tenantBarVisibilityListener);
        this.loadOrganizationContext();
        if (localStorage.getItem('token')) {
            this.accountService.getMyOrganizations().subscribe((memberships) => {
                if (memberships && memberships.length > 0) {
                    this.organizationMemberships = this.normalizeOrganizationMemberships(memberships);
                    this.syncHomeOrganizationFromMemberships();
                }
            }, () => {});
        }

        if (
            (!this.navigationItems || this.navigationItems.length === 0) &&
            this.navigationService.Items &&
            this.navigationService.Items.length > 0
        ) {
            this.navigationItems = this.navigationService.Items;
        } else {
            this.moduleService.getModules().subscribe((response) => {
                let sideBarLinks = [];
                const modules = response;
                let parentObj = {
                    label: 'Dashboard',
                    type: 'link',
                    icon: './assets/default/Custom/dashboard.svg',
                    children: [],
                    route: '/dashboard',
                    routerLinkActiveOptions: { exact: true }
                }

                sideBarLinks.push(parentObj);
                this.breadcrumbs.push(parentObj);
                modules.forEach((module) => {
                    const parent = this.makeMenu(module);
                    if (parent) {
                        sideBarLinks.push(parent);
                    }
                });
                this.navigationItems = sideBarLinks;
                this.navigationService.setItem(this.navigationItems);
                this.navigationService.setBreadCrumbs(this.breadcrumbs);
            });
        }
    }

    ngOnDestroy() {
        window.removeEventListener(this.tenantBarVisibilityEventName, this.tenantBarVisibilityListener);
    }

    get showOrganizationSwitcher(): boolean {
        return this.organizationMemberships.length > 0 || !!this.activeOrganizationId;
    }

    get showTenantContextBar(): boolean {
        return this.tenantBarVisible && this.showOrganizationSwitcher;
    }

    get canOpenGlobalConsole(): boolean {
        const info = this.authService.getUserInfo() || {};
        if ((info.TenantSwitchSource || info.tenantSwitchSource || '').toLowerCase() === 'ssh admin group') return true;
        const allowed = ['ssh admin group'];
        return (info.RoleArray || []).some((role) => allowed.includes((role?.Name || '').trim().toLowerCase()));
    }

    get isActingAsOrganization(): boolean {
        return !!this.homeOrganizationId &&
            !!this.activeOrganizationId &&
            this.homeOrganizationId !== this.activeOrganizationId;
    }

    get activeOrganizationName(): string {
        return this.getOrganizationName(this.activeOrganizationId);
    }

    get homeOrganizationName(): string {
        return this.getOrganizationName(this.homeOrganizationId);
    }

    get tenantContextSummary(): string {
        if (this.isActingAsOrganization) {
            return `Acting as ${this.activeOrganizationName || 'organization'} from ${this.homeOrganizationName || 'home organization'}`;
        }

        return `Current organization: ${this.activeOrganizationName || 'Organization'}`;
    }

    get activeOrganizationWorkspaceRoute(): any[] {
        return this.activeOrganizationId
            ? ['/platform-settings/organizations', this.activeOrganizationId]
            : ['/platform-settings/organizations'];
    }

    get organizationCenterRoute(): any[] {
        return ['/platform-settings/organizations'];
    }

    get activeOrganizationSettingsRoute(): any[] {
        return this.activeOrganizationId
            ? ['/platform-settings/organizations', this.activeOrganizationId, 'settings']
            : ['/platform-settings/organization-setting'];
    }

    get filteredOrganizationMemberships(): OrganizationMembership[] {
        const search = (this.organizationSearch || '').toLowerCase().trim();
        if (!search) {
            return this.organizationMemberships;
        }

        return this.organizationMemberships.filter((membership) =>
            (membership.OrganizationName || '').toLowerCase().includes(search) ||
            (membership.OrganizationId || '').toLowerCase().includes(search)
        );
    }

    loadOrganizationContext() {
        const info = JSON.parse(localStorage.getItem('Info') || 'null');
        if (!info) {
            return;
        }

        this.activeOrganizationId = info.OrganizationId || info.organizationId;
        this.homeOrganizationId = info.HomeOrganizationId || info.homeOrganizationId;
        this.organizationMemberships = this.normalizeOrganizationMemberships(info.OrganizationMemberships || info.organizationMemberships || []);
        if (this.organizationMemberships.length === 0 && this.activeOrganizationId) {
            this.organizationMemberships = [{
                OrganizationId: this.activeOrganizationId,
                OrganizationName: info.OrganizationName || info.organizationName || info.Organization || info.organization || this.activeOrganizationId,
                IsPrimary: true,
                Active: true
            }];
        }
        this.syncHomeOrganizationFromMemberships();
    }

    normalizeOrganizationMemberships(memberships: any[]): OrganizationMembership[] {
        return (memberships || [])
            .map((membership) => ({
                OrganizationId: membership.OrganizationId || membership.organizationId,
                OrganizationName: membership.OrganizationName || membership.organizationName,
                IsPrimary: membership.IsPrimary ?? membership.isPrimary,
                Active: membership.Active ?? membership.active
            }))
            .filter((membership) => membership.OrganizationId && membership.Active !== false);
    }

    syncHomeOrganizationFromMemberships() {
        // OrganizationId is the active tenant; HomeOrganizationId is the primary membership/home org.
        const primaryMembership = this.organizationMemberships.find((m) => m.IsPrimary);
        this.homeOrganizationId = primaryMembership?.OrganizationId || this.homeOrganizationId || this.activeOrganizationId;
    }

    getOrganizationName(organizationId: string): string {
        if (!organizationId) {
            return '';
        }

        const membership = this.organizationMemberships.find((m) => m.OrganizationId === organizationId);
        return membership?.OrganizationName || organizationId;
    }

    updateOrganizationSearch(value: string) {
        this.organizationSearch = value || '';
    }

    loadTenantBarVisibility() {
        const savedVisibility = localStorage.getItem(this.tenantBarVisibilityStorageKey);
        this.tenantBarVisible = savedVisibility !== 'false';
    }

    setTenantBarVisibility(visible: boolean) {
        this.tenantBarVisible = visible;
        localStorage.setItem(this.tenantBarVisibilityStorageKey, String(visible));
        window.dispatchEvent(new CustomEvent(this.tenantBarVisibilityEventName, {
            detail: { visible }
        }));
    }

    switchOrganization(organizationId: string) {
        if (!organizationId || organizationId === this.activeOrganizationId || this.isSwitchingOrganization) {
            return;
        }

        const switchedOrganizationUrl = this.getOrganizationRouteForSwitch(organizationId);
        this.isSwitchingOrganization = true;
        this.switchingOrganizationId = organizationId;
        this.accountService.switchOrganization(organizationId).subscribe(async (response) => {
            const user = response?.User;
            if (!user) {
                this.toastrService.error('Unable to switch organization.');
                this.isSwitchingOrganization = false;
                this.switchingOrganizationId = null;
                return;
            }

            user.Token = response.Token || user.Token;
            user.OrganizationName = response.OrganizationName || user.OrganizationName;
            user.OrganizationMemberships = this.withSwitchedOrganizationMembership(
                user.OrganizationMemberships || this.organizationMemberships,
                organizationId,
                user.OrganizationName
            );
            await this.authService.storeLatestUserData(user);
            this.loadOrganizationContext();
            this.toastrService.success('Organization context updated.');
            if (switchedOrganizationUrl && switchedOrganizationUrl !== this.router.url) {
                this.router.navigateByUrl(switchedOrganizationUrl).then(() => {
                    this.isSwitchingOrganization = false;
                    this.switchingOrganizationId = null;
                }, () => {
                    this.isSwitchingOrganization = false;
                    this.switchingOrganizationId = null;
                });
                return;
            }

            this.isSwitchingOrganization = false;
            this.switchingOrganizationId = null;
        }, (error) => {
            this.toastrService.error(this.getOrganizationSwitchError(error));
            this.isSwitchingOrganization = false;
            this.switchingOrganizationId = null;
        });
    }

    isOrganizationSwitching(organizationId: string): boolean {
        return this.isSwitchingOrganization && this.switchingOrganizationId === organizationId;
    }

    private getOrganizationRouteForSwitch(organizationId: string): string {
        const currentUrl = this.router.url || '';
        const organizationWorkspaceMatch = currentUrl.match(/^\/platform-settings\/organizations\/[^\/?#]+(.*)$/);
        if (organizationWorkspaceMatch) {
            return `/platform-settings/organizations/${organizationId}${organizationWorkspaceMatch[1] || ''}`;
        }

        if (currentUrl.startsWith('/platform-settings/organization-setting')) {
            return currentUrl.replace('/platform-settings/organization-setting', `/platform-settings/organizations/${organizationId}/settings`);
        }

        return '';
    }

    private getOrganizationSwitchError(error: any): string {
        const responseError = error?.error;
        if (typeof responseError === 'string' && responseError.trim()) {
            return responseError;
        }

        if (responseError?.message) {
            return responseError.message;
        }

        if (responseError?.Message) {
            return responseError.Message;
        }

        return 'Unable to switch organization.';
    }

    private withSwitchedOrganizationMembership(memberships: any[], organizationId: string, organizationName: string): OrganizationMembership[] {
        const normalizedMemberships = this.normalizeOrganizationMemberships(memberships);
        const existingMembership = normalizedMemberships.find((membership) => membership.OrganizationId === organizationId);
        if (existingMembership) {
            existingMembership.OrganizationName = organizationName || existingMembership.OrganizationName;
            existingMembership.Active = true;
            return normalizedMemberships;
        }

        normalizedMemberships.push({
            OrganizationId: organizationId,
            OrganizationName: organizationName || organizationId,
            IsPrimary: false,
            Active: true
        });
        return normalizedMemberships;
    }

    makeMenu(module, parentCrumbs: string[] = []) {
        if (!module) {
            return null;
        }

        const currentCrumbs = [...parentCrumbs, module.Name];
        
        const parent = {
            label: module.Name,
            type: (module.Features && module.Features.length > 0) ? 'dropdown' : 'link',
            icon: module.Icon
        };

        if (module.Features?.length > 0) {
            parent['children'] = [];
            module.Features.forEach((feature) => {
                const child = this.makeMenu(feature, currentCrumbs);
                if (child) {
                    parent['children'].push(child);
                }
            });
        } else {
            // Permission/module payloads can contain grouping records without a route.
            // Skipping an invalid leaf keeps one malformed record from removing the full menu.
            if (typeof module.Link !== 'string' || !module.Link.trim()) {
                return null;
            }

            const cleanLink = '/' + module.Link.replace(/^\/+/, '');
            const navigate = Array(currentCrumbs.length - 1).fill('./');
            navigate.push(cleanLink);

            this.breadcrumbs.push({
            PageId: module.Link,
            PageName: module.Name,
            Navigate: navigate,
            Crumbs: currentCrumbs,
            FeatureId: [module.Id] 
            });

            parent['route'] = module.Link;
        }
        return parent;
    }

    openQuickpanel() {
        this.layoutService.openQuickpanel();
    }

    openSidenav() {
        this.layoutService.openSidenav();
    }

    openMegaMenu(origin: ElementRef | HTMLElement) {
        this.popoverService.open({
            content: MegaMenuComponent,
            origin,
            offsetY: 10,
            position: [
                {
                    originX: 'start',
                    originY: 'bottom',
                    overlayX: 'start',
                    overlayY: 'top'
                },
                {
                    originX: 'end',
                    originY: 'bottom',
                    overlayX: 'end',
                    overlayY: 'top'
                }
            ]
        });
    }

    // openSearch() {
    //     this.layoutService.openSearch();
    // }
    openGlobalSearch(){
         return new Promise((resolve, reject) => {
            let dialogRef = this.dialog.open(GlobalSearchComponent, {
                width: '98%',
                maxWidth: '98vw',
                height: '95%',
                maxHeight: '95vw',
                disableClose: true,
                data: { hideFullScreenIcon : true }
            });
        });
    }

    openGlobalKumobot() {
        return new Promise((resolve, reject) => {
            let dialogRef = this.dialog.open(GlobalKumobotComponent, {
                width: '98%',
                maxWidth: '98vw',
                height: '95%',
                maxHeight: '95vw',
                disableClose: true,
                data: { hideFullScreenIcon : true }
            });
        });
    }

    openGlobalConsole() {
        return new Promise((resolve, reject) => {
            let dialogRef = this.dialog.open(GlobalConsoleComponent, {
                width: '100vw',
                maxWidth: '100vw',
                height: '100vh',
                maxHeight: '100vh',
                disableClose: true,
                panelClass: 'global-console-fullscreen',
                data: {}
            });
        });
    }
}
